(function(){
  function init(root){
    if(!root || root.dataset.qspReady === 'true') return;
    root.dataset.qspReady = 'true';

    var dataUrl=root.getAttribute('data-qsp-data-url');
    var input=root.querySelector('.qsp-buscar');
    var prov=root.querySelector('.qsp-provincia');
    var tipo=root.querySelector('.qsp-tipo');
    var list=root.querySelector('.qsp-lista');
    var nav=root.querySelector('.qsp-nav');
    var count=root.querySelector('.qsp-count');
    var empty=root.querySelector('.qsp-empty');
    var clear=root.querySelector('.qsp-limpiar');
    var loading=root.querySelector('.qsp-loading');
    var data=[];
    var provinces=[];

    function esc(s){
      return String(s||'').replace(/[&<>"']/g,function(c){
        return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c];
      });
    }
    function norm(s){
      var value=String(s||'').toLowerCase();
      return value.normalize ? value.normalize('NFD').replace(/[\u0300-\u036f]/g,'') : value;
    }
    function slug(s){
      return norm(s).replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
    }
    function phoneHref(phone){
      var first=String(phone||'').split('/')[0];
      var digits=first.replace(/\D/g,'');
      if(!digits) return '';
      if(digits.length===7 || digits.length===8) digits='507'+digits;
      return 'tel:+'+digits;
    }
    function mapUrl(name,address){
      return 'https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(name+', '+address+', Panamá');
    }
    function card(a){
      var city=a[1],type=a[2],name=a[3],address=a[4],phone=a[5],hours=a[6],email=a[7]||'';
      var tel=phoneHref(phone);
      var phoneHtml=tel?'<a href="'+tel+'">'+esc(phone)+'</a>':'<strong>'+esc(phone)+'</strong>';
      var emailHtml=email?'<div class="qsp-row"><span aria-hidden="true">✉️</span><p><a href="mailto:'+esc(email)+'">'+esc(email)+'</a></p></div>':'';
      var tagClass=type==='CDS'?'qsp-tag-cds':'qsp-tag-av';
      var tagText=type==='CDS'?'Centro de solución':'Agente verde';
      return '<article class="qsp-branch">'+
        '<div class="qsp-head"><div><div class="qsp-city">'+esc(city)+'</div><h4>'+esc(name)+'</h4></div><span class="qsp-tag '+tagClass+'">'+tagText+'</span></div>'+
        '<div class="qsp-row"><span aria-hidden="true">📍</span><p>'+esc(address)+'</p></div>'+
        '<div class="qsp-row"><span aria-hidden="true">📞</span><p>'+phoneHtml+'</p></div>'+
        emailHtml+
        '<div class="qsp-row"><span aria-hidden="true">🕒</span><p>'+esc(hours)+'</p></div>'+
        '<div class="qsp-card-wrap"><a href="'+mapUrl(name,address)+'" target="_blank" rel="noopener">Ver mapa</a><button type="button" data-copy="'+esc(address)+'">Copiar dirección</button></div>'+
      '</article>';
    }
    function render(){
      var q=norm(input.value);
      var selectedProv=prov.value;
      var selectedType=tipo.value;
      var filtered=data.filter(function(a){
        var text=norm(a.join(' '));
        return (!q || text.indexOf(q)>=0) &&
          (selectedProv==='all' || a[0]===selectedProv) &&
          (selectedType==='all' || a[2]===selectedType);
      });

      list.innerHTML='';
      provinces.forEach(function(p){
        var items=filtered.filter(function(a){return a[0]===p;});
        if(!items.length) return;
        var sectionId=root.id+'-'+slug(p);
        list.insertAdjacentHTML('beforeend',
          '<section id="'+sectionId+'"><h3 class="qsp-prov">'+esc(p)+'<span>'+items.length+(items.length===1?' ubicación':' ubicaciones')+'</span></h3><div class="qsp-grid">'+items.map(card).join('')+'</div></section>'
        );
      });
      count.textContent=filtered.length;
      empty.hidden=filtered.length!==0;
    }
    function buildControls(){
      provinces=[];
      data.forEach(function(a){if(provinces.indexOf(a[0])<0) provinces.push(a[0]);});
      provinces.forEach(function(p){
        prov.insertAdjacentHTML('beforeend','<option value="'+esc(p)+'">'+esc(p)+'</option>');
        var qty=data.filter(function(a){return a[0]===p;}).length;
        nav.insertAdjacentHTML('beforeend','<a href="#'+root.id+'-'+slug(p)+'">'+esc(p)+' <span>'+qty+'</span></a>');
      });
    }
    function showError(){
      if(loading) loading.textContent='No fue posible cargar el directorio. Recarga la página o escríbenos por WhatsApp.';
    }

    fetch(dataUrl,{credentials:'same-origin'})
      .then(function(response){if(!response.ok) throw new Error('HTTP '+response.status);return response.json();})
      .then(function(result){
        data=result;
        if(loading) loading.hidden=true;
        buildControls();
        render();
      })
      .catch(function(){showError();});

    input.addEventListener('input',render);
    prov.addEventListener('change',render);
    tipo.addEventListener('change',render);
    clear.addEventListener('click',function(){
      input.value='';
      prov.value='all';
      tipo.value='all';
      render();
      input.focus();
    });
    list.addEventListener('click',function(event){
      var btn=event.target.closest('button[data-copy]');
      if(!btn) return;
      var text=btn.getAttribute('data-copy');
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(text).then(function(){
          btn.textContent='Copiado';
          setTimeout(function(){btn.textContent='Copiar dirección';},1200);
        });
      }
    });
  }

  function initAll(){
    document.querySelectorAll('.qsp-envios[data-qsp-data-url]').forEach(init);
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initAll);
  }else{
    initAll();
  }
  document.addEventListener('shopify:section:load',function(event){
    var root=event.target.querySelector('.qsp-envios[data-qsp-data-url]');
    if(root) init(root);
  });
})();